import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Appcost(props) {
    return (
        <div className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Idea">
                            <h2>Let’s Discuss Your MVP Software Development Idea!</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>Do you have an incredible digital product idea? We can tell you all about MVP software development and how we build MVPs at TekRevol.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Appcost;
